const navigateToGoSiteWithRound = (redirectUrl, roundId) => {
    return `${process.env.REACT_APP_GO_LOGIN}?redirectUrl=${redirectUrl}&roundId=${roundId}&t=${localStorage.getItem('auth_token')}`
  }
  
  export default navigateToGoSiteWithRound
  